export const BUYING = 'BUYING';
export const SELLING = 'SELLING';
